import { Box } from "@mui/material";
import { SchedulerLog } from "./SchedulerLog";
import { SchedulerStatusCard } from "./SchedulerStatusCard";

export const SchedulerTabPage = () => {
  return (
    <Box>
      <SchedulerStatusCard/>
      <Box sx={{ p: 1 }}/>
      <Box maxWidth="680px">
        <SchedulerLog />
      </Box>
    </Box>
  );
};
